// extracted by mini-css-extract-plugin
export default {"assignmentList":"AssignmentList_assignmentList__2yds+"};